module.exports = __webpack_public_path__ + "img/car-4.ed416b24.png";